import { IntlShape, MessageDescriptor } from 'react-intl';

import messages from './messages';
import { ChainFallbackReason } from './types';

const FALLBACK_MESSAGES: Record<ChainFallbackReason, MessageDescriptor> = {
  no_value: messages.approverFallbackNoValue,
  other_account: messages.approverFallbackOtherAccount,
  no_permission: messages.approverFallbackNoPermission,
};

/**
 * What picked this approver, as it follows their name: "· Opening owner", or on
 * a backup standing in for one, "· Backup (no Opening owner on this opening)".
 *
 * Shared by every surface that names a request's approvers (the Send Offer
 * preview, the decision dialog, the request's chain), so one person reads the
 * same way on all of them.
 *
 * @param subjectType the request's subject, `Funnel` for an opening
 * @return null for a person named on the rule
 */
export const approverSourceText = (
  intl: IntlShape,
  {
    sourceLabel,
    fallbackReason,
  }: { sourceLabel: string | null; fallbackReason: ChainFallbackReason | null },
  subjectType?: string,
): string | null => {
  if (!sourceLabel) return null;

  const source = fallbackReason
    ? intl.formatMessage(FALLBACK_MESSAGES[fallbackReason], {
        source: sourceLabel,
        subject: subjectType ?? 'OfferLetter',
      })
    : sourceLabel;

  return intl.formatMessage(messages.approverSourceBeside, { source });
};
